import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage as Translation } from 'react-intl';
import withConfig from 'HOCs/withConfig/withConfig';
import { compose } from 'redux';
import css from './ReportUserMX.scss';

export const ReportUserMX = ({ user, config, intl }) => {
    const reportEmail = config.get('reportEmail');
    const formattedEmailBody = intl.formatMessage(
        { id: 'reportUserEmailBody' },
        { userId: user.id }
    );
    const formattedSubject = intl.formatMessage(
        { id: 'reportUserEmailSubject' },
        { userId: user.id }
    );

    return (
        <React.Fragment>
            <div className={ css.reportText }>
                <Translation id="reportUserModalTitleMX" />
            </div>
            <a
                className={ css.reportLink }
                href={ `mailto:${reportEmail}?subject=${formattedSubject}&body=${encodeURIComponent(formattedEmailBody)}` }
            >
                {reportEmail}
            </a>
        </React.Fragment>
    );
};

ReportUserMX.propTypes = {
    user: PropTypes.object.isRequired,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

ReportUserMX.defaultProps = {
    user: {}
};

export default compose(
    withConfig,
    injectIntl,
    React.memo
)(ReportUserMX);
